/* @flow */
import Entity from 'lib/Entity';
import Subscriber from 'entities/Subscriber';
import _ from 'lodash';

// The relationship between a user and a group
class GroupMembership extends Entity {
  initialize() {
    this.urlRoot = '/members';
  }

  parse(response: Object) {
    const membership = _.clone(response);
    membership['created_at'] = new Date(membership['created_at']);
    membership['user'] = Subscriber.fromJSON(membership['user']);
    return membership;
  }

  /**
   * TODO change uses of this to getSubscriber
   * @return {Subscriber} 'user' attribute as Subscriber model
   */
  getUser(): Subscriber {
    return this.get('user');
  }

  getSubscriber(): Subscriber {
    return this.get('user');
  }

  getUserId(): number {
    return this.get('user').id;
  }

  getName(): string {
    return this.get('user').getName();
  }

  getCanBecomeOwner(): boolean {
    return this.get('can_become_owner');
  }

  getCreatedAt(): Date {
    return this.get('created_at');
  }

  getRole(): ?string {
    return this.get('role');
  }

  isBlocked(): boolean {
    return this.get('user').get('blocked');
  }

  isOwner(): boolean {
    return this.getRole() === 'owner';
  }

  getQueryKey(): string {
    return this.get('query_key');
  }

  getTag(): string {
    return this.get('tag');
  }

  getGroupId(): ?number {
    return this.get('group_id');
  }

  getCanUnsubscribe(): boolean {
    return this.get('can_unsubscribe');
  }

  getCanChat(): boolean {
    return this.get('can_chat');
  }

  getChatEligibilityState(): string {
    return this.get('chat_eligibility_state');
  }

  getOrgAffiliationView(): ?Object {
    return this.get('org_affiliation_view');
  }

  hasPermission(permission: string): bool {
    const permissions = this.get('permissions');
    if (permissions) {
      return !!permissions[permission];
    }
    return false;
  }
}

export default GroupMembership;



// WEBPACK FOOTER //
// ./src/entities/GroupMembership.js